import type { ElectronAPI } from '../../../electron/src/shared/types'

function base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binary = atob(base64)
  const buffer = new ArrayBuffer(binary.length)
  const bytes = new Uint8Array(buffer)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  return buffer
}

export async function downloadServerFileToBrowser(api: Pick<
  ElectronAPI,
  'prepareFileDownload' | 'readFileDownloadChunk' | 'finishFileDownload'
>, path: string): Promise<void> {
  const info = await api.prepareFileDownload(path)
  const chunks: ArrayBuffer[] = []

  try {
    for (let index = 0; index < info.chunkCount; index++) {
      const chunk = await api.readFileDownloadChunk(info.downloadId, index)
      if (chunk.downloadId !== info.downloadId || chunk.index !== index) {
        throw new Error('Download chunk order mismatch')
      }
      chunks.push(base64ToArrayBuffer(chunk.dataBase64))
    }
  } finally {
    await api.finishFileDownload(info.downloadId).catch(() => {})
  }

  const blob = new Blob(chunks, { type: info.mimeType || 'application/octet-stream' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = info.name || 'download'
  anchor.style.display = 'none'
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
